import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  * {\n    box-sizing: border-box;\n  }\n\n  body {\n    margin: 0;\n    font-family: ", ";\n    ", ";\n    color: ", ";\n  }\n\n  a {\n    color: ", ";\n    background-color: transparent;\n    text-decoration: none;\n    outline: none;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  svg {\n    display: block;\n    line-height: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
export var InjectGlobalStyle = createGlobalStyle(_templateObject(), normalize, function (_ref) {
  var theme = _ref.theme;
  return theme.typography.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.variants.body2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text.base;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary.base;
});